import React from "react";

const Testing = () => {
  return <div>Testing</div>;
};

export default Testing;
